import { css } from "@emotion/react";

import { colors, dimensions } from "@styles";

export const header = css`
  display: flex;
  flex-direction: column;
  background-color: ${colors.backgroundWhite};

  color: ${colors.grey.base};

  padding: 0.5rem 0;

  @media screen and (max-width: ${dimensions.phoneLargeMax}) {
    padding: 1rem 0;
  }
`;
